import Badge from './badge'

export const AmuiBadge = Badge

export default Vue => Vue.component(Badge.name, Badge)
